import type { MessageDescriptor } from 'react-intl';

import { fantasy } from '@sorare/core/src/lib/glossary';

import {
  AnySportPlayerScoreStats,
  BaseballPlayerScoreStats,
  FootballPlayerScoreStats,
  NBAPlayerScoreStats,
} from './types';

const footballStatTitle = {
  [FootballPlayerScoreStats.DS]: fantasy.decisiveScoreShort,
  [FootballPlayerScoreStats.AA]: fantasy.allAroundShort,
};

const baseballStatTitle = {
  [BaseballPlayerScoreStats.TOTAL_SCORE]: {
    id: 'FixtureTopPlayersTableHeader.totalScore',
    defaultMessage: 'Total score',
  },
  [BaseballPlayerScoreStats.AB]: {
    id: 'FixtureTopPlayersTableHeader.ab',
    defaultMessage: 'AB',
  },
  [BaseballPlayerScoreStats.R]: {
    id: 'FixtureTopPlayersTableHeader.r',
    defaultMessage: 'R',
  },
  [BaseballPlayerScoreStats.H]: {
    id: 'FixtureTopPlayersTableHeader.h',
    defaultMessage: 'H',
  },
  [BaseballPlayerScoreStats.RBI]: {
    id: 'FixtureTopPlayersTableHeader.rbi',
    defaultMessage: 'RBI',
  },
  [BaseballPlayerScoreStats.HR]: {
    id: 'FixtureTopPlayersTableHeader.hr',
    defaultMessage: 'HR',
  },
  [BaseballPlayerScoreStats.BB]: {
    id: 'FixtureTopPlayersTableHeader.bb',
    defaultMessage: 'BB',
  },
  [BaseballPlayerScoreStats.K]: {
    id: 'FixtureTopPlayersTableHeader.K',
    defaultMessage: 'K',
  },
  [BaseballPlayerScoreStats.AVG]: {
    id: 'FixtureTopPlayersTableHeader.avg',
    defaultMessage: 'AVG',
  },
  [BaseballPlayerScoreStats.OBP]: {
    id: 'FixtureTopPlayersTableHeader.obp',
    defaultMessage: 'OBP',
  },
  [BaseballPlayerScoreStats.SLG]: {
    id: 'FixtureTopPlayersTableHeader.slg',
    defaultMessage: 'SLG',
  },
  [BaseballPlayerScoreStats.MATCHUPS]: {
    id: 'FixtureTopPlayersTableHeader.matchups.capitalCase',
    defaultMessage: 'Matchups',
  },
  [BaseballPlayerScoreStats.L5]: {
    id: 'FixtureTopPlayersTableHeader.l5',
    defaultMessage: 'L5',
  },
  [BaseballPlayerScoreStats.L15]: {
    id: 'FixtureTopPlayersTableHeader.l15',
    defaultMessage: 'L15',
  },
};

const nbaStatTitle: Record<NBAPlayerScoreStats, MessageDescriptor> = {
  [NBAPlayerScoreStats.L10]: fantasy.l10,
  [NBAPlayerScoreStats.DIFF]: {
    id: 'FixtureTopPlayersTableHeader.diff',
    defaultMessage: 'DIFF.',
  },
  [NBAPlayerScoreStats.MIN]: {
    id: 'FixtureTopPlayersTableHeader.min',
    defaultMessage: 'MIN',
  },
  [NBAPlayerScoreStats.THREE_PT]: {
    id: 'FixtureTopPlayersTableHeader.threePt',
    defaultMessage: '3PT',
  },
  [NBAPlayerScoreStats.REB]: {
    id: 'FixtureTopPlayersTableHeader.reb',
    defaultMessage: 'REB',
  },
  [NBAPlayerScoreStats.AST]: {
    id: 'FixtureTopPlayersTableHeader.ast',
    defaultMessage: 'AST',
  },
  [NBAPlayerScoreStats.STL]: {
    id: 'FixtureTopPlayersTableHeader.stl',
    defaultMessage: 'STL',
  },
  [NBAPlayerScoreStats.BLK]: {
    id: 'FixtureTopPlayersTableHeader.blk',
    defaultMessage: 'BLK',
  },
  [NBAPlayerScoreStats.TO]: {
    id: 'FixtureTopPlayersTableHeader.to',
    defaultMessage: 'TO',
  },
  [NBAPlayerScoreStats.PTS]: {
    id: 'FixtureTopPlayersTableHeader.pts',
    defaultMessage: 'PTS',
  },
  [NBAPlayerScoreStats.GAMES]: {
    id: 'FixtureTopPlayersTableHeader.games.capitalCase',
    defaultMessage: 'Games',
  },
  [NBAPlayerScoreStats.TOT]: {
    id: 'FixtureTopPlayersTableHeader.tot',
    defaultMessage: 'TOT',
  },
};

export const playerStatTitle = {
  [AnySportPlayerScoreStats.SCORE]: fantasy.score,
  [AnySportPlayerScoreStats.PROJECTED_SCORE]: fantasy.projectedScoreShort,
  [AnySportPlayerScoreStats.FORM]: {
    id: 'FixtureTopPlayersTableHeader.form.capitalCase',
    defaultMessage: 'Form',
  },
  [AnySportPlayerScoreStats.PRICE]: {
    id: 'FixtureTopPlayersTableHeader.price.capitalCase',
    defaultMessage: 'Price',
  },
  ...footballStatTitle,
  ...baseballStatTitle,
  ...nbaStatTitle,
};
